<template>
  <div>
    <Card>
      <div class="filter-container">
        <el-input clearable
                  @keyup.enter.native="searchBtnClick"
                  style="width: 200px;"
                  class="filter-item"
                  placeholder="店铺名称"
                  v-model="searchData.query" />
        <el-button size="medium"
                   class="filter-item"
                   type="primary"
                   icon="el-icon-search"
                   @click="searchBtnClick()">搜索</el-button>
      </div>
      <TablePaginate :columns="columns"
                     :data="shops"
                     :loading="loading"
                     :meta="meta"
                     :changePage="changePage"></TablePaginate>
    </Card>
    <!-- <Modal v-model="modalShow2"
           @on-ok="handleSubmit"
           title="激活码">
      <Form ref="shop"
            :model="shop"
            :label-width="120">
        <Form-item label="输入激活码"
                   prop="activation_code">
          <Input type="text"
                 v-model="shop.activation_code" />
        </Form-item>
      </Form>
    </Modal> -->
    <Modal v-model="modalShow"
           @on-ok="handleSubmit2"
           title="更新店铺名称">
      <Form ref="shop"
            :model="shop"
            :label-width="120">
        <Form-item label="输入店铺名称"
                   prop="name">
          <Input type="text"
                 v-model="shop.name" />
        </Form-item>
      </Form>
    </Modal>
    <binding-main-shop ref="bindingMainShop" @bind="bindParentShop"/>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { find } from 'lodash'
import TablePaginate from '@/components/TablePaginate'
import BindingMainShop from '@/components/binding-main-shop'
import { editorButtonInTable, commonButtonInTable } from '@/libs/table-render'

export default {
  components: {
    TablePaginate,
    BindingMainShop
  },
  data () {
    const vm = this
    return {
      searchData: {
        id: undefined
      },
      modalShow: false,
      // modalShow2: false,
      current_shop_id: 0,
      columns: [
        {
          title: 'ID',
          key: 'id',
          width: 100
        },
        {
          title: '店铺名',
          width: 220,
          key: 'name'
        },
        {
          title: '所属连锁店',
          width: 220,
          key: 'chain_store_name'
        },
        {
          title: '在线支付',
          width: 120,
          align: 'center',
          key: 'lcsw_account_status'
        },
        {
          title: '软件版本',
          width: 120,
          align: 'center',
          render: (h, params) => {
            return h(
              'div',
              find(vm.fresh_software_versions, { name: params.row.software_version_name }).title || params.row.software_version_name
            )
          }
        },
        // {
        //   title: '激活时间',
        //   width: 200,
        //   align: 'center',
        //   key: 'activated_at_str'
        // },
        {
          title: '操作',
          key: 'action',
          align: 'left',
          fixed: 'right',
          width: 250,
          render: (h, params) => {
            const children = []
            children.push(editorButtonInTable(this, h, params))
            // if (params.row.software_version_name !== 'standard') {
            //   children.push(
            //     commonButtonInTable(
            //       this,
            //       h,
            //       'success',
            //       '升级标准版',
            //       this.shop_upgrade,
            //       [params.row.id]
            //     )
            //   )
            // }
            // children.push(
            //   commonButtonInTable(
            //     this,
            //     h,
            //     params.row.is_cloned_main_shop ? 'error' : 'success',
            //     params.row.is_cloned_main_shop ? '降级成普通店铺' : '升级成连锁主店',
            //     this.handleUpAndDown,
            //     [params.row.id]
            //   )
            // )
            if (!params.row.is_cloned_main_shop) {
              children.push(
                commonButtonInTable(
                  this,
                  h,
                  'success',
                  '升级成连锁主店',
                  this.handleUpAndDown,
                  [params.row.id]
                )
              )
            }
            if (!params.row.parent_shop_id && !params.row.is_cloned_main_shop) {
              children.push(
                commonButtonInTable(
                  this,
                  h,
                  'success',
                  '绑定到主店',
                  this.showBindShop,
                  [params.row.id]
                )
              )
            }
            if (params.row.parent_shop_id) {
              children.push(
                commonButtonInTable(
                  this,
                  h,
                  'error',
                  `解绑${params.row.parent_shop_name}`,
                  this.unbindParentShop,
                  [{
                    parent_shop_id: params.row.parent_shop_id,
                    id: params.row.id
                  }]
                )
              )
            }
            return h('div', children)
          }
        }
      ]
    }
  },
  created () {
    this.resetQuery()
    this.changeQuery({ page: 1 })
    this.index()
    this.current_shop_id = 0
    this.versionsIndex()
  },
  computed: {
    ...mapGetters('shop', ['shop', 'shops', 'meta', 'loading']),
    ...mapGetters('fresh_software_version', ['fresh_software_versions'])
  },
  methods: {
    ...mapActions('shop', [
      'clear',
      'index',
      'show',
      'create',
      'update',
      'destroy',
      // 'activate',
      // 'shop_reduce',
      'mark_cloned_main',
      'bind_parent_shop',
      'unbind_parent_shop'
    ]),
    ...mapActions('fresh_software_version', { versionsIndex: 'index' }),
    ...mapMutations('shop', ['changeQuery', 'resetQuery', 'mainShopId']),
    showBindShop (id) {
      this.mainShopId(id)
      this.$refs.bindingMainShop.show()
    },
    async bindParentShop (id) {
      await this.bind_parent_shop(id)
      await this.index()
    },
    async unbindParentShop (params) {
      await this.unbind_parent_shop(params)
      await this.index()
    },
    async handleUpAndDown (id) {
      await this.mark_cloned_main(id)
      await this.index()
    },
    changePage (page) {
      this.changeQuery({ page: page })
      this.index()
    },
    shop_select (shop_id) {
      this.index()
    },
    searchBtnClick () {
      this.resetQuery()
      this.changeQuery(this.searchData)
      this.index()
    },
    // shop_upgrade (id) {
    //   this.clear()
    //   this.modalShow2 = true
    //   this.current_shop_id = id
    // },
    // async handleSubmit () {
    //   this.activate({
    //     activation_code: this.shop.activation_code,
    //     id: this.current_shop_id
    //   })
    //   this.modalShow2 = false
    //   this.index()
    // },
    handleSubmit2 () {
      this.update(this.shop)
      this.modalShow = false
      this.index()
    }
  }
}
</script>
